import React from 'react'
import AddExpenseFlyout from 'src/app/AddExpenseFlyout/AddExpenseFlyout'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { addExpenseRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const AddExpenseAppRoute: AppRoute = {
  id: AppLocation.AddExpense,
  routeProps: addExpenseRouteProps,
  component: <AddExpenseFlyout />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default AddExpenseAppRoute
